// utils/orderUtils.js

/**
 * Захиалгын үлдсэн бэлтгэх хугацаа (секунд) эсвэл null.
 *
 * ⭐ ЗӨВХӨН СЕРВЕРЭЭР. `fetchNewOrders` нь `prepRemainingSec`-ийг DB-ийн цагаар
 * (`prepStartedAt` + `prepDuration`) тооцож poll бүрт буцаадаг; жагсаалт татсан
 * мөчөөс (`_fetchedAt`) хойш өнгөрсөн секундыг хасна. Тиймээс АЛЬ Ч ТӨХӨӨРӨМЖИД
 * зөв харагдана.
 *
 * ⚠️ Хуучин localStorage (`order_*_startTime/_duration`) fallback-ийг УСТГАВ
 * (2026-10-08): тэр нь зөвхөн «Бэлдэх» дарсан төхөөрөмжид бичигддэг, өөр таблет
 * дээр «-», cache цэвэрлэхэд алдагддаг байв. Сервер = эх сурвалж.
 *
 * @param {object|number} orderOrId — захиалгын объект эсвэл id
 * @returns {number|null} — 0-оос бага болохгүй; серверийн утга байхгүй бол null
 */
export const getRemainingTime = (orderOrId) => {
  const order = typeof orderOrId === "object" && orderOrId ? orderOrId : null;
  if (order && typeof order.prepRemainingSec === "number") {
    const elapsed = order._fetchedAt ? Math.floor((Date.now() - order._fetchedAt) / 1000) : 0;
    return Math.max(0, order.prepRemainingSec - elapsed);
  }
  return null;
};

/** Хугацаа сунгах товч харуулах эсэх: бэлдэж байгаа, хугацаа дууссан, сунгаагүй. */
export const canExtendPrep = (order, remaining) =>
  order?.status?.id === 3 &&
  remaining === 0 &&
  typeof order?.prepRemainingSec === "number" &&
  Number(order?.prepExtendCount || 0) < 1;

// Function to format remaining time as MM:SS
export const formatTime = (seconds) => {
  if (seconds === null) return "-";
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};

/** Жолоочийн төлөвийн шошго (зөвхөн ЭНЭ ресторан руу явж/ирсэн үед). */
export const DRIVER_STAGE_LABEL = {
  HEADING: { text: "Жолооч ирж байна", className: "badge bg-primary" },
  ARRIVED: { text: "Жолооч ирсэн", className: "badge bg-success" },
};
